import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useState } from "react";
import { url } from "../utils/config";
import { FiAlertCircle } from "react-icons/fi";

function ImageSlider({ images, imageUrlInfix }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    if (!Array.isArray(images) || images.length === 0) {
        return (
            <div className='text-center p-6 text-gray-500 flex flex-col items-center gap-2'>
                <FiAlertCircle size={48} />
                <p>No Image Found</p>
            </div>
        );
    }

    const goPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goNext = () => {
        setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className='flex flex-col items-center gap-2 my-1'>
            <div className='relative w-full max-w-3xl'>
                <img
                    src={`${url}/${imageUrlInfix}/${images[currentIndex]}`}
                    alt={`Slide ${currentIndex + 1}`}
                    className='w-full max-h-[400px] object-contain rounded-xl shadow-xl  transition duration-500 ease-in-out'
                />

                <button
                    onClick={goPrev}
                    className='absolute top-1/2 left-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-100 transition'
                >
                    <FiChevronLeft size={24} />
                </button>

                <button
                    onClick={goNext}
                    className='absolute top-1/2 right-4 transform -translate-y-1/2 bg-white p-2 rounded-full shadow hover:bg-gray-100 transition'
                >
                    <FiChevronRight size={24} />
                </button>
            </div>

            <div className='text-gray-600 text-sm'>
                Image {currentIndex + 1} of {images.length}
            </div>
        </div>
    );
}

export default ImageSlider;
